import React, { useContext, useEffect, useState } from 'react';
import {
    getTopicsBySubjectId,
    getQuestionsByTopicId,
    deleteQuestion,
    getQuestionTypes,
    getQuestionLevels,
    getLanguagesType,
    getTeachersSubjects
} from '../../../actions';

import { Context } from '../../../defaults';
import {
    Row,
    Col,
    Select,
    Popconfirm,
    Tooltip,
    message,
    Table
} from 'antd';
import { DeleteTwoTone, EditTwoTone } from '@ant-design/icons';
import { QuestionsModal } from './QuestionsModal';

export const QuestionsTable = () => {
    const { dictionary, language, setLoading } = useContext(Context);
    const [topics, setTopics] = useState();
    const [edit, setEdit] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [questionTypes, setQuestionTypes] = useState([]);
    const [languagesType, setLanguagesType] = useState([]);
    const [questionLevels, setQuestionLevels] = useState([]);
    const [teacherSubjects, setTeacherSubjects] = useState();
    const [selectedSubjects, setSelectedSubjects] = useState();
    const [selectedTopic, setSelectedTopic] = useState();
    const [selectedQuestion, setSelectedQuestion] = useState();
    const [subjectsEl, setSubjectsEl] = useState();
    const [languages, setLanguages] = useState();
    const [modalProps, setModalProps] = useState({
        visible: false,
        actionType: null,
        currentQuestion: null,
    });

    const onSelectTopic = (id) => {
        if (id) {
            setSelectedTopic(id);
            getQuestionsByTopicId(id)
                .then(({ data }) => {
                    setQuestions(data);
                    setLoading(false);
                })
                .catch(() => {
                    message.error(dictionary?.SomethingWentWrong[language]);
                    setLoading(false);
                });
            setEdit(true);
        } else {

        }
    };

    const onSelectSubject = (object) => {
        if (object) {
            setSelectedSubjects(object);
            setLoading(true);
            getTopicsBySubjectId(object)
                .then(({ data }) => {
                    setTopics(data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                    message.error(dictionary?.SomethingWentWrong[language]);
                });
        }
    };

    const onSelectQuestion = (value) => {
        setSelectedQuestion(value);
    }

    const confirm = (id) => {
        deleteQuestion(id)
            .then(() => {
                message.success(dictionary?.OperationSuccessful[language]);
                onSelectTopic(selectedTopic);
            })
            .catch(() => {
                setLoading(false);
                message.error(dictionary?.SomethingWentWrong[language]);
            });
    };

    const columns = [
        {
            title: `${dictionary?.Question[language]}`,
            fixed: 'left',
            render: (item) => (
                <div dangerouslySetInnerHTML={{ __html: item.questionHtml }}>
                </div>
            ),
        },
        {
            title: `${dictionary?.Action[language]}`,
            key: 'action',
            width: 150,
            fixed: 'right',
            align: 'center',
            render: ({ id }) => (
                <>
                    <Tooltip placement="top" title={dictionary?.Edit[language]}>
                        <EditTwoTone key="edit"
                            onClick={() => {
                                setModalProps({
                                    visible: !modalProps.visible,
                                    actionType: 'edit',
                                    currentQuestion: questions && questions.find((el) => el.id === id),
                                });
                            }} />
                    </Tooltip>
                </>
            ),
        },
        {
            title: `${dictionary?.Action[language]}`,
            key: 'action',
            width: 150,
            fixed: 'right',
            align: 'center',
            render: ({ id }) => (
                <>
                    <Tooltip placement="top" title={dictionary?.Delete[language]}>
                        <Popconfirm
                            placement="bottom"
                            title={dictionary?.AreYouSureToDelete[language]}
                            onConfirm={() => confirm(id)}
                            okText={dictionary?.Yes[language]}
                            cancelText={dictionary?.No[language]}>
                            <DeleteTwoTone key="delete" twoToneColor="#eb2f96" />
                        </Popconfirm>
                    </Tooltip>
                </>
            ),
        },
    ];

    const closeModal = () => {
        setModalProps({ visible: false });
        if (selectedTopic) {
            onSelectTopic(selectedTopic);
        }
    }

    useEffect(() => {
        getQuestionTypes().then(({ data }) => setQuestionTypes(data));
        getLanguagesType().then(({ data }) => setLanguagesType(data));
        getQuestionLevels().then(({ data }) => setQuestionLevels(data));
        getTeachersSubjects().then(({ data }) => setTeacherSubjects(data));
    }, []);

    return (
        <React.Fragment>
            <QuestionsModal modalProps={modalProps} closeModal={closeModal} languagesType={languages} questionLevels={questionLevels} />
            <Row gutter={16}>
                <Col span={6}>
                    <Select
                        placeholder={dictionary?.Subject[language]}
                        allowClear={true}
                        showSearch={true}
                        style={{ width: '100%' }}
                        value={selectedSubjects}
                        size='large'
                        onChange={value => onSelectSubject(value)}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {!!teacherSubjects &&
                            teacherSubjects.map((el) => {
                                return (
                                    <Select.Option value={el.id} key={`school${el.id}`}>
                                        {el.name}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </Col>
                <Col span={6}>
                    <Select
                        placeholder={dictionary?.Topic[language]}
                        allowClear={true}
                        showSearch={true}
                        style={{ width: '100%' }}
                        value={selectedTopic}
                        size='large'
                        onChange={value => onSelectTopic(value)}
                    >
                        {!!topics &&
                            topics.map((el) => {
                                return (
                                    <Select.Option value={el.id} key={`school${el.id}`}>
                                        {el.name}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </Col>
            </Row>
            <Table
                style={{ marginTop: 24 }}
                columns={columns}
                dataSource={questions}
                rowKey="id"
            />
        </React.Fragment>
    );
};